import {inject, injectable} from 'inversify';

import type {Expand, Expanded, MaybeExpanded} from '../../../../api/types';
import type {CouponMapperJrpc} from '../../Coupon/mappers/Coupon.mapper.jrpc';
import type {SubtenantMapperJrpc} from '../../Subtenant/mappers/Subtenant.mapper.jrpc';
import type {UserMapperJrpc} from '../../User/mappers/User.mapper.jrpc';

import {EnvProviderService} from '../../../system/env/EnvProvider.service';
import {BaseExpandJrpc} from '../../Base/mappers/Base.expand.jrpc';
import {CouponExpandJrpc} from '../../Coupon/mappers/Coupon.expand.jrpc';
import {SubtenantExpandJrpc} from '../../Subtenant/mappers/Subtenant.expand.jrpc';
import {UserExpandJrpc} from '../../User/mappers/User.expand.jrpc';

@injectable()
export class WaitlistItemExpandJrpc extends BaseExpandJrpc {
  constructor(
    @inject(EnvProviderService) env: EnvProviderService,
    @inject(UserExpandJrpc)
    private userExpand: UserExpandJrpc,
    @inject(SubtenantExpandJrpc)
    private subtenantExpand: SubtenantExpandJrpc,
    @inject(CouponExpandJrpc)
    private couponExpand: CouponExpandJrpc,
  ) {
    super(env);
  }

  getByEnv(key?: BaseExpandJrpc.EnvKey): Expand {
    const base: Expand = {
      waitlist_item: [
        ['user_id', {name: 'User not found'}, this.userExpand.getByEnv(key)],
        ['subtenant_id', null, this.subtenantExpand.getByEnv(key)],
        ['coupon_id', null, this.couponExpand.getByEnv(key)],
      ],
    };
    const core: Expand = base;
    const b2b: Expand = base;

    return this.resolve({b2b, core, key});
  }
}

export namespace WaitlistItemExpandJrpc {
  export type ExpandedFields = {
    coupon: MaybeExpanded<CouponMapperJrpc.ExpandedApiData>;
    subtenant: MaybeExpanded<SubtenantMapperJrpc.ExpandedApiData>;
    user: Expanded<UserMapperJrpc.ExpandedApiData, 'name'>;
  };
}
